export const ASSIGNMENT_HINT_STEPS = {
  gradeMoreSubmissions: {
    element: "[data-testid='grade-more-submissions-button']",
    popover: {
      title: "Grade More Submissions",
      description:
        "Want to grade more essays in this assignment? Upload them here — your rubric and grading settings will be applied automatically.",
      side: "left",
      align: "center",
    },
  },
};
